import { useState } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { IStations } from "../../../interfaces/endpoints/IStations";
import Localizations from "../../bundles/Localizations";
import Input from "../../ui/input/Input";

const MultpileLangFieldsCity = () => {
  const {
    register,
    formState: { errors },
    control
  } = useFormContext<IStations>();
  const { fields } = useFieldArray({
    control,
    name: "city.locales",
    keyName: "uuid"
  });

  const [langIdActive, setLangIdActive] = useState<1 | 2>(2);

  return (
    <div className="rounded-xl bg-gray-100 p-3">
      <Localizations
        activeId={langIdActive}
        onChange={setLangIdActive}
        alError={!!errors.city?.locales?.length && !!errors.city.locales[1]}
        enError={!!errors.city?.locales?.length && !!errors.city.locales[0]}
      />
      <div className="overflow-hidden mt-2 -mx-2">
        <div
          className={`transform duration-500 transition-all w-full flex
    ${langIdActive === 1 ? "translate-x-0" : "-translate-x-full"}`}
        >
          {fields.map((field, index) => {
            return (
              <Input
                key={field.uuid}
                label="Emri i Qytetit*"
                className="flex-none w-full px-2 mb-2"
                {...register(`city.locales.${index}.name`)}
                placeholder="Shkruaj emrin e qytetit këtu..."
                // error={
                //   errors.city?.locales &&
                //   errors?.city?.locales[index]?.name?.message
                // }
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MultpileLangFieldsCity;
